
import { Header, Hero, Features, About, Footer } from "@/components/home";
import Pricing from "@/components/Pricing";

const Index = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-1">
        <Hero />
        <Features />
        <Pricing />
        <About />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
